import { generateRecentIsoTimestamp } from "../utils/timestamp"
import {
  generateMetricDay,
  generateMetricWeek,
  generateMetricMonth,
  generateMetricYear,
  generateDayData,
  generateWeekData,
  generateMonthData,
  generateYearData
} from "utils/generateAnalyticsData";

const driverAnalytics = {
  driverAnalytics: [
    {
      name: "Ahmed Al Mansoori",
      licenseNo: "PB2586",
      generalStats: {
        day: {
          totalTrips: "200",
          avgDistanceDriven: "1524 miles",
          avgDrivingHours: "100Hrs",
          avgLabourCost: "300$",
          avgDrivingScore: "90%",
        },
        weekly: {
          totalTrips: "300",
          avgDistanceDriven: "1524 miles",
          avgDrivingHours: "100Hrs",
          avgLabourCost: "300$",
          avgDrivingScore: "90%",
        },
        monthly: {
          totalTrips: "400",
          avgDistanceDriven: "1524 miles",
          avgDrivingHours: "100Hrs",
          avgLabourCost: "300$",
          avgDrivingScore: "70%",
        },
        yearly: {
          totalTrips: "500",
          avgDistanceDriven: "1524 miles",
          avgDrivingHours: "100Hrs",
          avgLabourCost: "300$",
          avgDrivingScore: "50%",
        },
      },
      tripStats: {
        day: {
          trips: "200",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateDayData(),
        },
        weekly: {
          trips: "200",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          trips: "200",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          trips: "200",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateYearData(),
        },
      },
      avgDistanceDrivenStats: {
        day: {
          totalDistanceDriven: "1524",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceDriven: "1524",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceDriven: "1524",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceDriven: "1524",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateYearData(),
        },
      },
      labourCostStats: {
        day: {
          labourCost: "$100",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateDayData(),
        },
        weekly: {
          labourCost: "$200",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          labourCost: "$300",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          labourCost: "$400",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateYearData(),
        },
      },
      driveTimeStats: {
        day: {
          driveTime: "05Hrs",
          driveObservation: "up",
          drivePercentage: "1.0%",
          idleTime: "1Hrs",
          idleObservation: "down",
          idlePercentage: "0.5%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          driveTime: "05Hrs",
          driveObservation: "up",
          drivePercentage: "1.0%",
          idleTime: "1Hrs",
          idleObservation: "down",
          idlePercentage: "0.5%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          driveTime: "05Hrs",
          driveObservation: "up",
          drivePercentage: "1.0%",
          idleTime: "1Hrs",
          idleObservation: "down",
          idlePercentage: "0.5%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          driveTime: "05Hrs",
          driveObservation: "up",
          drivePercentage: "1.0%",
          idleTime: "1Hrs",
          idleObservation: "down",
          idlePercentage: "0.5%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      violationsStats: {
        day: {
          overspeeding: "2",
          harshBraking: "5",
          harshAccelaration: "3",
          sharpCorner: "1",
          distractions: "1",
          otherViolations: "0",
          highFatigue: "1",
        },
        weekly: {
          overspeeding: "10",
          harshBraking: "25",
          harshAccelaration: "15",
          sharpCorner: "5",
          distractions: "3",
          otherViolations: "1",
          highFatigue: "4",
        },
        monthly: {
          overspeeding: "40",
          harshBraking: "100",
          harshAccelaration: "60",
          sharpCorner: "20",
          distractions: "10",
          otherViolations: "4",
          highFatigue: "16",
        },
        yearly: {
          overspeeding: "120",
          harshBraking: "300",
          harshAccelaration: "180",
          sharpCorner: "60",
          distractions: "30",
          otherViolations: "12",
          highFatigue: "48",
        },
      },
    },
    {
      name: "Salem bin Nasser",
      licenseNo: "PB2586",
      generalStats: {
        day: {
          totalTrips: "800",
          avgDistanceDriven: "2524 miles",
          avgDrivingHours: "500Hrs",
          avgLabourCost: "800$",
          avgDrivingScore: "50%",
        },
        weekly: {
          totalTrips: "1800",
          avgDistanceDriven: "2524 miles",
          avgDrivingHours: "500Hrs",
          avgLabourCost: "800$",
          avgDrivingScore: "50%",
        },
        monthly: {
          totalTrips: "500",
          avgDistanceDriven: "2524 miles",
          avgDrivingHours: "500Hrs",
          avgLabourCost: "800$",
          avgDrivingScore: "50%",
        },
        yearly: {
          totalTrips: "500",
          avgDistanceDriven: "2524 miles",
          avgDrivingHours: "500Hrs",
          avgLabourCost: "800$",
          avgDrivingScore: "50%",
        },
      },
      tripStats: {
        day: {
          trips: "100",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateDayData(),
        },
        weekly: {
          trips: "200",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          trips: "300",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          trips: "400",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateYearData(),
        },
      },
      avgDistanceDrivenStats: {
        day: {
          totalDistanceDriven: "2524",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceDriven: "3524",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceDriven: "1524",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceDriven: "5524",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateYearData(),
        },
      },
      labourCostStats: {
        day: {
          labourCost: "$500",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateDayData(),
        },
        weekly: {
          labourCost: "$200",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          labourCost: "$300",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          labourCost: "$400",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateYearData(),
        },
      },
      driveTimeStats: {
        day: {
          driveTime: "10Hrs",
          driveObservation: "up",
          drivePercentage: "1.0%",
          idleTime: "1Hrs",
          idleObservation: "down",
          idlePercentage: "0.5%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          driveTime: "05Hrs",
          driveObservation: "up",
          drivePercentage: "1.0%",
          idleTime: "1Hrs",
          idleObservation: "down",
          idlePercentage: "0.5%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          driveTime: "05Hrs",
          driveObservation: "up",
          drivePercentage: "1.0%",
          idleTime: "1Hrs",
          idleObservation: "down",
          idlePercentage: "0.5%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          driveTime: "05Hrs",
          driveObservation: "up",
          drivePercentage: "1.0%",
          idleTime: "1Hrs",
          idleObservation: "down",
          idlePercentage: "0.5%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      violationsStats: {
        day: {
          overspeeding: "3",
          harshBraking: "6",
          harshAccelaration: "4",
          sharpCorner: "2",
          distractions: "1",
          otherViolations: "1",
          highFatigue: "2",
        },
        weekly: {
          overspeeding: "15",
          harshBraking: "30",
          harshAccelaration: "20",
          sharpCorner: "10",
          distractions: "5",
          otherViolations: "3",
          highFatigue: "8",
        },
        monthly: {
          overspeeding: "60",
          harshBraking: "120",
          harshAccelaration: "80",
          sharpCorner: "40",
          distractions: "20",
          otherViolations: "10",
          highFatigue: "32",
        },
        yearly: {
          overspeeding: "180",
          harshBraking: "360",
          harshAccelaration: "240",
          sharpCorner: "120",
          distractions: "60",
          otherViolations: "30",
          highFatigue: "96",
        },
      },
    },
    {
      name: "Hessa Al Shehhi",
      licenseNo: "PB2587",
      generalStats: {
        day: {
          totalTrips: "150",
          avgDistanceDriven: "1200 miles",
          avgDrivingHours: "80Hrs",
          avgLabourCost: "250$",
          avgDrivingScore: "82%",
        },
        weekly: {
          totalTrips: "250",
          avgDistanceDriven: "1200 miles",
          avgDrivingHours: "80Hrs",
          avgLabourCost: "250$",
          avgDrivingScore: "75%",
        },
        monthly: {
          totalTrips: "350",
          avgDistanceDriven: "1200 miles",
          avgDrivingHours: "80Hrs",
          avgLabourCost: "250$",
          avgDrivingScore: "65%",
        },
        yearly: {
          totalTrips: "450",
          avgDistanceDriven: "1200 miles",
          avgDrivingHours: "80Hrs",
          avgLabourCost: "250$",
          avgDrivingScore: "45%",
        },
      },
      tripStats: {
        day: {
          trips: "150",
          observation: "down",
          percentage: "0.2%",
          analyticsData: generateDayData(),
        },
        weekly: {
          trips: "150",
          observation: "down",
          percentage: "0.2%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          trips: "150",
          observation: "down",
          percentage: "0.2%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          trips: "150",
          observation: "down",
          percentage: "0.2%",
          analyticsData: generateYearData(),
        },
      },
      avgDistanceDrivenStats: {
        day: {
          totalDistanceDriven: "1200",
          observation: "down",
          percentage: "2.0%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceDriven: "1200",
          observation: "down",
          percentage: "2.0%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceDriven: "1200",
          observation: "down",
          percentage: "2.0%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceDriven: "1200",
          observation: "down",
          percentage: "2.0%",
          analyticsData: generateYearData(),
        },
      },
      labourCostStats: {
        day: {
          labourCost: "$80",
          observation: "down",
          percentage: "0.2%",
          analyticsData: generateDayData(),
        },
        weekly: {
          labourCost: "$180",
          observation: "down",
          percentage: "0.2%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          labourCost: "$280",
          observation: "down",
          percentage: "0.2%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          labourCost: "$380",
          observation: "down",
          percentage: "0.2%",
          analyticsData: generateYearData(),
        },
      },
      driveTimeStats: {
        day: {
          driveTime: "04Hrs",
          driveObservation: "down",
          drivePercentage: "0.8%",
          idleTime: "0.5Hrs",
          idleObservation: "up",
          idlePercentage: "0.2%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          driveTime: "04Hrs",
          driveObservation: "down",
          drivePercentage: "0.8%",
          idleTime: "0.5Hrs",
          idleObservation: "up",
          idlePercentage: "0.2%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          driveTime: "04Hrs",
          driveObservation: "down",
          drivePercentage: "0.8%",
          idleTime: "0.5Hrs",
          idleObservation: "up",
          idlePercentage: "0.2%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          driveTime: "04Hrs",
          driveObservation: "down",
          drivePercentage: "0.8%",
          idleTime: "0.5Hrs",
          idleObservation: "up",
          idlePercentage: "0.2%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      violationsStats: {
        day: {
          overspeeding: "1",
          harshBraking: "3",
          harshAccelaration: "2",
          sharpCorner: "1",
          distractions: "0",
          otherViolations: "0",
          highFatigue: "1",
        },
        weekly: {
          overspeeding: "5",
          harshBraking: "15",
          harshAccelaration: "10",
          sharpCorner: "4",
          distractions: "1",
          otherViolations: "0",
          highFatigue: "3",
        },
        monthly: {
          overspeeding: "20",
          harshBraking: "60",
          harshAccelaration: "40",
          sharpCorner: "16",
          distractions: "4",
          otherViolations: "2",
          highFatigue: "12",
        },
        yearly: {
          overspeeding: "60",
          harshBraking: "180",
          harshAccelaration: "120",
          sharpCorner: "48",
          distractions: "12",
          otherViolations: "6",
          highFatigue: "36",
        },
      },
    },
    {
      name: "Irfan Pathan",
      licenseNo: "PB2588",
      generalStats: {
        day: {
          totalTrips: "220",
          avgDistanceDriven: "1600 miles",
          avgDrivingHours: "110Hrs",
          avgLabourCost: "320$",
          avgDrivingScore: "92%",
        },
        weekly: {
          totalTrips: "320",
          avgDistanceDriven: "1600 miles",
          avgDrivingHours: "110Hrs",
          avgLabourCost: "320$",
          avgDrivingScore: "92%",
        },
        monthly: {
          totalTrips: "420",
          avgDistanceDriven: "1600 miles",
          avgDrivingHours: "110Hrs",
          avgLabourCost: "320$",
          avgDrivingScore: "72%",
        },
        yearly: {
          totalTrips: "520",
          avgDistanceDriven: "1600 miles",
          avgDrivingHours: "110Hrs",
          avgLabourCost: "320$",
          avgDrivingScore: "52%",
        },
      },
      tripStats: {
        day: {
          trips: "220",
          observation: "up",
          percentage: "0.6%",
          analyticsData: generateDayData(),
        },
        weekly: {
          trips: "220",
          observation: "up",
          percentage: "0.6%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          trips: "220",
          observation: "up",
          percentage: "0.6%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          trips: "220",
          observation: "up",
          percentage: "0.6%",
          analyticsData: generateYearData(),
        },
      },
      avgDistanceDrivenStats: {
        day: {
          totalDistanceDriven: "1600",
          observation: "up",
          percentage: "3.2%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceDriven: "1600",
          observation: "up",
          percentage: "3.2%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceDriven: "1600",
          observation: "up",
          percentage: "3.2%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceDriven: "1600",
          observation: "up",
          percentage: "3.2%",
          analyticsData: generateYearData(),
        },
      },
      labourCostStats: {
        day: {
          labourCost: "$110",
          observation: "up",
          percentage: "0.6%",
          analyticsData: generateDayData(),
        },
        weekly: {
          labourCost: "$210",
          observation: "up",
          percentage: "0.6%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          labourCost: "$310",
          observation: "up",
          percentage: "0.6%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          labourCost: "$410",
          observation: "up",
          percentage: "0.6%",
          analyticsData: generateYearData(),
        },
      },
      driveTimeStats: {
        day: {
          driveTime: "06Hrs",
          driveObservation: "up",
          drivePercentage: "1.2%",
          idleTime: "1.2Hrs",
          idleObservation: "down",
          idlePercentage: "0.6%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          driveTime: "06Hrs",
          driveObservation: "up",
          drivePercentage: "1.2%",
          idleTime: "1.2Hrs",
          idleObservation: "down",
          idlePercentage: "0.6%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          driveTime: "06Hrs",
          driveObservation: "up",
          drivePercentage: "1.2%",
          idleTime: "1.2Hrs",
          idleObservation: "down",
          idlePercentage: "0.6%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          driveTime: "06Hrs",
          driveObservation: "up",
          drivePercentage: "1.2%",
          idleTime: "1.2Hrs",
          idleObservation: "down",
          idlePercentage: "0.6%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      violationsStats: {
        day: {
          overspeeding: "2",
          harshBraking: "4",
          harshAccelaration: "3",
          sharpCorner: "1",
          distractions: "1",
          otherViolations: "0",
          highFatigue: "1",
        },
        weekly: {
          overspeeding: "10",
          harshBraking: "20",
          harshAccelaration: "15",
          sharpCorner: "5",
          distractions: "2",
          otherViolations: "1",
          highFatigue: "4",
        },
        monthly: {
          overspeeding: "40",
          harshBraking: "80",
          harshAccelaration: "60",
          sharpCorner: "20",
          distractions: "8",
          otherViolations: "4",
          highFatigue: "16",
        },
        yearly: {
          overspeeding: "120",
          harshBraking: "240",
          harshAccelaration: "180",
          sharpCorner: "60",
          distractions: "24",
          otherViolations: "12",
          highFatigue: "48",
        },
      },
    },
    {
      name: "Azaharuddin",
      licenseNo: "PB2589",
      generalStats: {
        day: {
          totalTrips: "180",
          avgDistanceDriven: "1400 miles",
          avgDrivingHours: "90Hrs",
          avgLabourCost: "280$",
          avgDrivingScore: "88%",
        },
        weekly: {
          totalTrips: "280",
          avgDistanceDriven: "1400 miles",
          avgDrivingHours: "90Hrs",
          avgLabourCost: "280$",
          avgDrivingScore: "88%",
        },
        monthly: {
          totalTrips: "380",
          avgDistanceDriven: "1400 miles",
          avgDrivingHours: "90Hrs",
          avgLabourCost: "280$",
          avgDrivingScore: "68%",
        },
        yearly: {
          totalTrips: "480",
          avgDistanceDriven: "1400 miles",
          avgDrivingHours: "90Hrs",
          avgLabourCost: "280$",
          avgDrivingScore: "48%",
        },
      },
      tripStats: {
        day: {
          trips: "180",
          observation: "down",
          percentage: "0.4%",
          analyticsData: generateDayData(),
        },
        weekly: {
          trips: "180",
          observation: "down",
          percentage: "0.4%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          trips: "180",
          observation: "down",
          percentage: "0.4%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          trips: "180",
          observation: "down",
          percentage: "0.4%",
          analyticsData: generateYearData(),
        },
      },
      avgDistanceDrivenStats: {
        day: {
          totalDistanceDriven: "1400",
          observation: "down",
          percentage: "2.8%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceDriven: "1400",
          observation: "down",
          percentage: "2.8%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceDriven: "1400",
          observation: "down",
          percentage: "2.8%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceDriven: "1400",
          observation: "down",
          percentage: "2.8%",
          analyticsData: generateYearData(),
        },
      },
      labourCostStats: {
        day: {
          labourCost: "$90",
          observation: "down",
          percentage: "0.4%",
          analyticsData: generateDayData(),
        },
        weekly: {
          labourCost: "$190",
          observation: "down",
          percentage: "0.4%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          labourCost: "$290",
          observation: "down",
          percentage: "0.4%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          labourCost: "$390",
          observation: "down",
          percentage: "0.4%",
          analyticsData: generateYearData(),
        },
      },
      driveTimeStats: {
        day: {
          driveTime: "04.5Hrs",
          driveObservation: "down",
          drivePercentage: "0.9%",
          idleTime: "0.8Hrs",
          idleObservation: "up",
          idlePercentage: "0.4%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          driveTime: "04.5Hrs",
          driveObservation: "down",
          drivePercentage: "0.9%",
          idleTime: "0.8Hrs",
          idleObservation: "up",
          idlePercentage: "0.4%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          driveTime: "04.5Hrs",
          driveObservation: "down",
          drivePercentage: "0.9%",
          idleTime: "0.8Hrs",
          idleObservation: "up",
          idlePercentage: "0.4%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          driveTime: "04.5Hrs",
          driveObservation: "down",
          drivePercentage: "0.9%",
          idleTime: "0.8Hrs",
          idleObservation: "up",
          idlePercentage: "0.4%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      violationsStats: {
        day: {
          overspeeding: "1",
          harshBraking: "2",
          harshAccelaration: "1",
          sharpCorner: "1",
          distractions: "0",
          otherViolations: "0",
          highFatigue: "0",
        },
        weekly: {
          overspeeding: "4",
          harshBraking: "10",
          harshAccelaration: "5",
          sharpCorner: "3",
          distractions: "1",
          otherViolations: "0",
          highFatigue: "2",
        },
        monthly: {
          overspeeding: "16",
          harshBraking: "40",
          harshAccelaration: "20",
          sharpCorner: "12",
          distractions: "4",
          otherViolations: "1",
          highFatigue: "8",
        },
        yearly: {
          overspeeding: "48",
          harshBraking: "120",
          harshAccelaration: "60",
          sharpCorner: "36",
          distractions: "12",
          otherViolations: "3",
          highFatigue: "24",
        },
      },
    },
    {
      name: "Mohammed Kaif",
      licenseNo: "PB2590",
      generalStats: {
        day: {
          totalTrips: "250",
          avgDistanceDriven: "1800 miles",
          avgDrivingHours: "120Hrs",
          avgLabourCost: "350$",
          avgDrivingScore: "95%",
        },
        weekly: {
          totalTrips: "350",
          avgDistanceDriven: "1800 miles",
          avgDrivingHours: "120Hrs",
          avgLabourCost: "350$",
          avgDrivingScore: "95%",
        },
        monthly: {
          totalTrips: "450",
          avgDistanceDriven: "1800 miles",
          avgDrivingHours: "120Hrs",
          avgLabourCost: "350$",
          avgDrivingScore: "75%",
        },
        yearly: {
          totalTrips: "550",
          avgDistanceDriven: "1800 miles",
          avgDrivingHours: "120Hrs",
          avgLabourCost: "350$",
          avgDrivingScore: "55%",
        },
      },
      tripStats: {
        day: {
          trips: "200",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateDayData(),
        },
        weekly: {
          trips: "200",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          trips: "200",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          trips: "200",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateYearData(),
        },
      },
      avgDistanceDrivenStats: {
        day: {
          totalDistanceDriven: "1800",
          observation: "up",
          percentage: "3.5%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceDriven: "1800",
          observation: "up",
          percentage: "3.5%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceDriven: "1800",
          observation: "up",
          percentage: "3.5%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceDriven: "1800",
          observation: "up",
          percentage: "3.5%",
          analyticsData: generateYearData(),
        },
      },
      labourCostStats: {
        day: {
          labourCost: "$120",
          observation: "up",
          percentage: "0.7%",
          analyticsData: generateDayData(),
        },
        weekly: {
          labourCost: "$220",
          observation: "up",
          percentage: "0.7%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          labourCost: "$320",
          observation: "up",
          percentage: "0.7%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          labourCost: "$420",
          observation: "up",
          percentage: "0.7%",
          analyticsData: generateYearData(),
        },
      },
      driveTimeStats: {
        day: {
          driveTime: "07Hrs",
          driveObservation: "up",
          drivePercentage: "1.4%",
          idleTime: "1.5Hrs",
          idleObservation: "down",
          idlePercentage: "0.7%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          driveTime: "07Hrs",
          driveObservation: "up",
          drivePercentage: "1.4%",
          idleTime: "1.5Hrs",
          idleObservation: "down",
          idlePercentage: "0.7%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          driveTime: "07Hrs",
          driveObservation: "up",
          drivePercentage: "1.4%",
          idleTime: "1.5Hrs",
          idleObservation: "down",
          idlePercentage: "0.7%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          driveTime: "07Hrs",
          driveObservation: "up",
          drivePercentage: "1.4%",
          idleTime: "1.5Hrs",
          idleObservation: "down",
          idlePercentage: "0.7%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      violationsStats: {
        day: {
          overspeeding: "1",
          harshBraking: "1",
          harshAccelaration: "1",
          sharpCorner: "0",
          distractions: "0",
          otherViolations: "0",
          highFatigue: "0",
        },
        weekly: {
          overspeeding: "3",
          harshBraking: "5",
          harshAccelaration: "2",
          sharpCorner: "1",
          distractions: "0",
          otherViolations: "0",
          highFatigue: "1",
        },
        monthly: {
          overspeeding: "12",
          harshBraking: "20",
          harshAccelaration: "8",
          sharpCorner: "4",
          distractions: "1",
          otherViolations: "1",
          highFatigue: "4",
        },
        yearly: {
          overspeeding: "36",
          harshBraking: "60",
          harshAccelaration: "24",
          sharpCorner: "12",
          distractions: "3",
          otherViolations: "2",
          highFatigue: "12",
        },
      },
    },
    {
      name: "Noor Ahmed",
      licenseNo: "PB2591",
      generalStats: {
        day: {
          totalTrips: "190",
          avgDistanceDriven: "1450 miles",
          avgDrivingHours: "95Hrs",
          avgLabourCost: "290$",
          avgDrivingScore: "89%",
        },
        weekly: {
          totalTrips: "290",
          avgDistanceDriven: "1450 miles",
          avgDrivingHours: "95Hrs",
          avgLabourCost: "290$",
          avgDrivingScore: "89%",
        },
        monthly: {
          totalTrips: "390",
          avgDistanceDriven: "1450 miles",
          avgDrivingHours: "95Hrs",
          avgLabourCost: "290$",
          avgDrivingScore: "69%",
        },
        yearly: {
          totalTrips: "490",
          avgDistanceDriven: "1450 miles",
          avgDrivingHours: "95Hrs",
          avgLabourCost: "290$",
          avgDrivingScore: "49%",
        },
      },
      tripStats: {
        day: {
          trips: "190",
          observation: "down",
          percentage: "0.45%",
          analyticsData: generateDayData(),
        },
        weekly: {
          trips: "190",
          observation: "down",
          percentage: "0.45%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          trips: "190",
          observation: "down",
          percentage: "0.45%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          trips: "190",
          observation: "down",
          percentage: "0.45%",
          analyticsData: generateYearData(),
        },
      },
      avgDistanceDrivenStats: {
        day: {
          totalDistanceDriven: "1450",
          observation: "down",
          percentage: "2.9%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceDriven: "1450",
          observation: "down",
          percentage: "2.9%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceDriven: "1450",
          observation: "down",
          percentage: "2.9%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceDriven: "1450",
          observation: "down",
          percentage: "2.9%",
          analyticsData: generateYearData(),
        },
      },
      labourCostStats: {
        day: {
          labourCost: "$95",
          observation: "down",
          percentage: "0.45%",
          analyticsData: generateDayData(),
        },
        weekly: {
          labourCost: "$195",
          observation: "down",
          percentage: "0.45%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          labourCost: "$295",
          observation: "down",
          percentage: "0.45%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          labourCost: "$395",
          observation: "down",
          percentage: "0.45%",
          analyticsData: generateYearData(),
        },
      },
      driveTimeStats: {
        day: {
          driveTime: "04.8Hrs",
          driveObservation: "down",
          drivePercentage: "0.95%",
          idleTime: "0.9Hrs",
          idleObservation: "up",
          idlePercentage: "0.45%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          driveTime: "04.8Hrs",
          driveObservation: "down",
          drivePercentage: "0.95%",
          idleTime: "0.9Hrs",
          idleObservation: "up",
          idlePercentage: "0.45%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          driveTime: "04.8Hrs",
          driveObservation: "down",
          drivePercentage: "0.95%",
          idleTime: "0.9Hrs",
          idleObservation: "up",
          idlePercentage: "0.45%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          driveTime: "04.8Hrs",
          driveObservation: "down",
          drivePercentage: "0.95%",
          idleTime: "0.9Hrs",
          idleObservation: "up",
          idlePercentage: "0.45%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      violationsStats: {
        day: {
          overspeeding: "1",
          harshBraking: "2",
          harshAccelaration: "1",
          sharpCorner: "0",
          distractions: "0",
          otherViolations: "0",
          highFatigue: "1",
        },
        weekly: {
          overspeeding: "5",
          harshBraking: "10",
          harshAccelaration: "5",
          sharpCorner: "2",
          distractions: "1",
          otherViolations: "0",
          highFatigue: "3",
        },
        monthly: {
          overspeeding: "20",
          harshBraking: "40",
          harshAccelaration: "20",
          sharpCorner: "8",
          distractions: "4",
          otherViolations: "1",
          highFatigue: "12",
        },
        yearly: {
          overspeeding: "60",
          harshBraking: "120",
          harshAccelaration: "60",
          sharpCorner: "24",
          distractions: "12",
          otherViolations: "3",
          highFatigue: "36",
        },
      },
    },
    {
      name: "Mohammed Usmaan",
      licenseNo: "PB2592",
      generalStats: {
        day: {
          totalTrips: "210",
          avgDistanceDriven: "1550 miles",
          avgDrivingHours: "105Hrs",
          avgLabourCost: "310$",
          avgDrivingScore: "91%",
        },
        weekly: {
          totalTrips: "310",
          avgDistanceDriven: "1550 miles",
          avgDrivingHours: "105Hrs",
          avgLabourCost: "310$",
          avgDrivingScore: "91%",
        },
        monthly: {
          totalTrips: "410",
          avgDistanceDriven: "1550 miles",
          avgDrivingHours: "105Hrs",
          avgLabourCost: "310$",
          avgDrivingScore: "71%",
        },
        yearly: {
          totalTrips: "510",
          avgDistanceDriven: "1550 miles",
          avgDrivingHours: "105Hrs",
          avgLabourCost: "310$",
          avgDrivingScore: "51%",
        },
      },
      tripStats: {
        day: {
          trips: "210",
          observation: "up",
          percentage: "0.55%",
          analyticsData: generateDayData(),
        },
        weekly: {
          trips: "210",
          observation: "up",
          percentage: "0.55%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          trips: "210",
          observation: "up",
          percentage: "0.55%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          trips: "210",
          observation: "up",
          percentage: "0.55%",
          analyticsData: generateYearData(),
        },
      },
      avgDistanceDrivenStats: {
        day: {
          totalDistanceDriven: "1550",
          observation: "up",
          percentage: "3.1%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalDistanceDriven: "1550",
          observation: "up",
          percentage: "3.1%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalDistanceDriven: "1550",
          observation: "up",
          percentage: "3.1%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalDistanceDriven: "1550",
          observation: "up",
          percentage: "3.1%",
          analyticsData: generateYearData(),
        },
      },
      labourCostStats: {
        day: {
          labourCost: "$105",
          observation: "up",
          percentage: "0.55%",
          analyticsData: generateDayData(),
        },
        weekly: {
          labourCost: "$205",
          observation: "up",
          percentage: "0.55%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          labourCost: "$305",
          observation: "up",
          percentage: "0.55%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          labourCost: "$405",
          observation: "up",
          percentage: "0.55%",
          analyticsData: generateYearData(),
        },
      },
      driveTimeStats: {
        day: {
          driveTime: "05.5Hrs",
          driveObservation: "up",
          drivePercentage: "1.1%",
          idleTime: "1.1Hrs",
          idleObservation: "down",
          idlePercentage: "0.55%",
          analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
        },
        weekly: {
          driveTime: "05.5Hrs",
          driveObservation: "up",
          drivePercentage: "1.1%",
          idleTime: "1.1Hrs",
          idleObservation: "down",
          idlePercentage: "0.55%",
          analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
        },
        monthly: {
          driveTime: "05.5Hrs",
          driveObservation: "up",
          drivePercentage: "1.1%",
          idleTime: "1.1Hrs",
          idleObservation: "down",
          idlePercentage: "0.55%",
          analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
        },
        yearly: {
          driveTime: "05.5Hrs",
          driveObservation: "up",
          drivePercentage: "1.1%",
          idleTime: "1.1Hrs",
          idleObservation: "down",
          idlePercentage: "0.55%",
          analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
        },
      },
      violationsStats: {
        day: {
          overspeeding: "1",
          harshBraking: "2",
          harshAccelaration: "1",
          sharpCorner: "0",
          distractions: "0",
          otherViolations: "0",
          highFatigue: "0",
        },
        weekly: {
          overspeeding: "4",
          harshBraking: "8",
          harshAccelaration: "4",
          sharpCorner: "1",
          distractions: "1",
          otherViolations: "0",
          highFatigue: "2",
        },
        monthly: {
          overspeeding: "16",
          harshBraking: "32",
          harshAccelaration: "16",
          sharpCorner: "4",
          distractions: "2",
          otherViolations: "1",
          highFatigue: "8",
        },
        yearly: {
          overspeeding: "48",
          harshBraking: "96",
          harshAccelaration: "48",
          sharpCorner: "12",
          distractions: "6",
          otherViolations: "3",
          highFatigue: "24",
        },
      },
    },
  ],
  overAllAnalytics: {
    generalStats: {
      day: {
        totalTrips: "2200",
        avgDistanceDriven: "1631 miles",
        avgDrivingHours: "185Hrs",
        avgLabourCost: "$1100",
        avgDrivingScore: "85%",
      },
      weekly: {
        totalTrips: "3550",
        avgDistanceDriven: "10631 miles",
        avgDrivingHours: "585Hrs",
        avgLabourCost: "$2100",
        avgDrivingScore: "85%",
      },
      monthly: {
        totalTrips: "4550",
        avgDistanceDriven: "21631 miles",
        avgDrivingHours: "785Hrs",
        avgLabourCost: "$3200",
        avgDrivingScore: "65%",
      },
      yearly: {
        totalTrips: "5550",
        avgDistanceDriven: "51631 miles",
        avgDrivingHours: "985Hrs",
        avgLabourCost: "$4100",
        avgDrivingScore: "45%",
      },
    },
    tripStats: {
      day: {
        avgTrips: "275",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateDayData(),
      },
      weekly: {
        avgTrips: "443",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateWeekData(),
      },
      monthly: {
        avgTrips: "568",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateMonthData(),
      },
      yearly: {
        avgTrips: "693",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateYearData(),
      },
    },
    avgDistanceDrivenStats: {
      day: {
        avgDistanceDriven: "1631",
        observation: "up",
        percentage: "3.0%",
        analyticsData: generateDayData(),
      },
      weekly: {
        avgDistanceDriven: "1631",
        observation: "up",
        percentage: "3.0%",
        analyticsData: generateWeekData(),
      },
      monthly: {
        avgDistanceDriven: "1631",
        observation: "up",
        percentage: "3.0%",
        analyticsData: generateMonthData(),
      },
      yearly: {
        avgDistanceDriven: "1631",
        observation: "up",
        percentage: "3.0%",
        analyticsData: generateYearData(),
      },
    },
    labourCostStats: {
      day: {
        avgLabourCost: "$262",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateDayData(),
      },
      weekly: {
        avgLabourCost: "$262",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateWeekData(),
      },
      monthly: {
        avgLabourCost: "$262",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateMonthData(),
      },
      yearly: {
        avgLabourCost: "$262",
        observation: "up",
        percentage: "0.5%",
        analyticsData:
          generateYearData(),
      },
    },
    driveTimeStats: {
      day: {
        avgDriveTime: "6.2Hrs",
        avgDriveObservation: "up",
        avgDrivePercentage: "1.0%",
        avgIdleTime: "1.0Hrs",
        avgIdleObservation: "down",
        avgIdlePercentage: "0.5%",
        analyticsData: generateMetricDay(2, 30, "Running Hours", "Idle Hours"),
      },
      weekly: {
        avgDriveTime: "6.2Hrs",
        avgDriveObservation: "up",
        avgDrivePercentage: "1.0%",
        avgIdleTime: "1.0Hrs",
        avdIdleObservation: "down",
        avgIdlePercentage: "0.5%",
        analyticsData: generateMetricWeek(2, 30, "Running Hours", "Idle Hours"),
      },
      monthly: {
        avgDriveTime: "6.2Hrs",
        avgDriveObservation: "up",
        avgDrivePercentage: "1.0%",
        avgIdleTime: "1.0Hrs",
        avdIdleObservation: "down",
        avgIdlePercentage: "0.5%",
        analyticsData: generateMetricMonth(2, 30, "Running Hours", "Idle Hours"),
      },
      yearly: {
        avgDriveTime: "6.2Hrs",
        avgDriveObservation: "up",
        avgDrivePercentage: "1.0%",
        avgIdleTime: "1.0Hrs",
        avdIdleObservation: "down",
        avgIdlePercentage: "0.5%",
        analyticsData: generateMetricYear(2, 30, "Running Hours", "Idle Hours"),
      },
    },
    violationsStats: {
      day: {
        overspeeding: "11",
        harshBraking: "24",
        harshAccelaration: "15",
        sharpCorner: "6",
        distractions: "3",
        otherViolations: "2",
        highFatigue: "6",
      },
      weekly: {
        overspeeding: "51",
        harshBraking: "118",
        harshAccelaration: "74",
        sharpCorner: "28",
        distractions: "13",
        otherViolations: "6",
        highFatigue: "23",
      },
      monthly: {
        overspeeding: "204",
        harshBraking: "472",
        harshAccelaration: "296",
        sharpCorner: "112",
        distractions: "52",
        otherViolations: "25",
        highFatigue: "92",
      },
      yearly: {
        overspeeding: "612",
        harshBraking: "1416",
        harshAccelaration: "888",
        sharpCorner: "336",
        distractions: "156",
        otherViolations: "75",
        highFatigue: "276",
      },
    },
  }
};

export default driverAnalytics;
